import { motion } from "framer-motion";
import { Leaf, Waves, Bird } from "lucide-react";
import { IMAGES } from "../../data/content";

const STATS = [
  { icon: Leaf, value: "100%", label: "Private nature reserve" },
  { icon: Waves, value: "Virgin", label: "Untouched Pacific shores" },
  { icon: Bird, value: "Chocó", label: "Among Earth's most biodiverse" },
];

export const About = () => {
  return (
    <section
      id="story"
      data-testid="about-section"
      className="relative bg-sand-100 py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-xs tracking-[0.25em] uppercase text-earth-600 font-semibold mb-5">
              Our Story
            </p>
            <h2 className="font-serif font-light text-forest-900 text-3xl sm:text-5xl leading-tight mb-7 text-balance">
              A sanctuary between the rainforest and the sea
            </h2>
            <div className="space-y-5 text-forest-500 text-base sm:text-lg leading-relaxed">
              <p>
                Mecana EcoHotel sits on a private nature reserve at Playa Mecana,
                in the remote municipality of Bahía Solano on Colombia's Pacific
                coast. Here, dense tropical rainforest gives way to mangrove
                estuaries and long, wild beaches.
              </p>
              <p>
                Built in harmony with its surroundings, the hotel is a place to
                slow down — to wake with the birds, walk forest trails to hidden
                waterfalls, and watch humpback whales pass just offshore. Every
                stay supports the conservation of one of the most biodiverse
                regions on the planet.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 sm:gap-8 mt-12 border-t border-forest-900/10 pt-10">
              {STATS.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.1 * i }}
                  data-testid={`about-stat-${i}`}
                >
                  <s.icon className="text-earth-500 mb-3" size={24} />
                  <div className="font-serif text-2xl sm:text-3xl text-forest-900">
                    {s.value}
                  </div>
                  <div className="text-xs sm:text-sm text-forest-500 mt-1 leading-snug">
                    {s.label}
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-[2rem] aspect-[4/5]">
              <img
                src={IMAGES.aboutForest}
                alt="Lush tropical rainforest of the Chocó region"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-8 -left-6 sm:-left-10 w-40 sm:w-56 overflow-hidden rounded-2xl border-4 border-sand-100 shadow-xl aspect-square">
              <img
                src={IMAGES.aboutBeach}
                alt="Aerial view of the jungle meeting the sea"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
